import type { PropsWithChildren } from 'react';
import * as styles from './gift.module.scss';

type SectionProps = {
  title: string;
  hasBottomBorder: boolean;
  image: string;
  className: string;
  classNameBorder: string;
  id: string;
};

const Section = ({
  children,
  title = '',
  hasBottomBorder = true,
  image,
  className,
  classNameBorder,
  id,
}: PropsWithChildren<SectionProps>) => (
  <section id={id} className={`${styles.section} ${className || ''}`}>
    {!image ? (
      <Title>{title}</Title>
    ) : (
      <div className={styles.sectionTitleWithImage}>
        <Title>{title}</Title>
        <div className={styles.sectionTitleImage}>
          <img src={image} alt="Card" />
        </div>
      </div>
    )}
    <div
      className={`${hasBottomBorder && styles.sectionBodyBottomBorder} ${classNameBorder || ''}`}
    >
      {children}
    </div>
  </section>
);

const Title = ({ children }: PropsWithChildren) => (
  <h3 className={styles.sectionTitle}>{children}</h3>
);

export default Section;
